export interface ErrorMessagesProps {
  errors: Record<string, { message: string }>;
}

export const ErrorMessages = ({ errors = {} }: ErrorMessagesProps) => {
  const errorEntries = Object.entries(errors);
  if (!errorEntries.length) {
    return null;
  }

  return (
    <>
      {errorEntries.map(([name, error]) => (
        <div key={name} className="form-errors">
          {error.message}
        </div>
      ))}
    </>
  );
};
